import { useEffect, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";

// context
import context from "../store/context";

// components
import NavigationBar from "../components/UI/NavigationBar";
import BottomNav from "../components/UI/BottomNav";
import TelegramBottomNav from "../components/UI/TelegramBottomNav";
import FloatingSearch from "../components/UI/FloatingSearch";
import Footer from "../components/UI/Footer";
import SearchSidebarPhone from "../components/section/SearchSidebarPhone";
import SearchSheetTelegram from "../Telegram/SearchSheetTelegram";

const Rootlayout = () => {
  const location = useLocation();
  const isPayHost = window.location.hostname === "pay.ichereta.com";
  const hideNavAndFooter =
    isPayHost ||
    location.pathname.startsWith("/signup") ||
    location.pathname.startsWith("/login") ||
    location.pathname.startsWith("/forgot-password") ||
    location.pathname.startsWith("/verification/") ||
    location.pathname.startsWith("/invoice/") ||
    location.pathname.startsWith("/payments") ||
    location.pathname.startsWith("/app") ||
    location.pathname.startsWith("/free") ||
    location.pathname.startsWith("/confirmation") ||
    location.pathname.startsWith("/trial") ||
    location.pathname.startsWith("/discount") ||
    location.pathname.startsWith("/pay-online-as-guest-user");

  const hideFooter =
    location.pathname.startsWith("/tender") ||
    location.pathname.startsWith("/myfeed") ||
    location.pathname.startsWith("/saved") ||
    location.pathname.startsWith("/myaccount") ||
    location.pathname.startsWith("/billing") ||
    location.pathname.startsWith("/settings") ||
    location.pathname.startsWith("/company");

  const token = localStorage.getItem("token");

  const { showSearchDarwer, showDrawerHandler } = useContext(context);

  const hideBottomNav =
    isPayHost ||
    location.pathname.startsWith("/verification") ||
    location.pathname.startsWith("/myaccount") ||
    location.pathname.startsWith("/billing") ||
    location.pathname.startsWith("/settings") ||
    location.pathname.startsWith("/invoice") ||
    location.pathname.startsWith("/payments") ||
    location.pathname.startsWith("/free") ||
    location.pathname.startsWith("/confirmation") ||
    location.pathname.startsWith("/trial") ||
    location.pathname.startsWith("/discount") ||
    location.pathname.startsWith("/pay-online-as-guest-user");

  const telegramPage =
    location.pathname.includes("/telegram");
  const telegramListPage =
    location.pathname === "/latest-tenders/telegram" ||
    location.pathname === "/myfeed/telegram" ||
    location.pathname === "/saved/telegram" ||
    location.pathname === "/account/telegram";

  const pathname = location.pathname;
  let pageTitle = pathname.replace(/^\/|\/$/g, "");
  pageTitle = pageTitle.charAt(0).toUpperCase() + pageTitle.slice(1);

  useEffect(() => {
    if (pathname === "/") {
      document.title = "iChereta";
    } else if (
      pathname.startsWith("/pay-online-as-guest-user") ||
      isPayHost
    ) {
      return;
    } else if (
      !pathname.startsWith("/company") &&
      !pathname.startsWith("/tender/")
    ) {
      document.title = pageTitle;
    } else if (pathname.startsWith("/verification")) {
      document.title = "Verification";
    }
  }, [pageTitle, pathname, isPayHost]);

  const tenderFilter = location.pathname.startsWith("/tender");
  const feedFilter = location.pathname.startsWith("/myfeed");

  return (
    <div className="flex flex-col items-center w-full">
      <div className="flex flex-col items-center  min-h-screen w-full">
        {showSearchDarwer && telegramPage && (
          <SearchSheetTelegram
            onClick={showDrawerHandler}
            filter={
              location.pathname.startsWith("/myfeed")
                ? "myfeed"
                : location.pathname.startsWith("/saved")
                ? "saved"
                : ""
            }
            redirectTo={
              location.pathname.startsWith("/myfeed/telegram")
                ? "/myfeed/telegram"
                : location.pathname.startsWith("/saved/telegram")
                ? "/saved/telegram"
                : "/latest-tenders/telegram"
            }
          />
        )}
        {showSearchDarwer && !telegramPage && (
          <SearchSidebarPhone
            onClick={showDrawerHandler}
            filter={
              tenderFilter ? "" : feedFilter ? "myfeed" : "saved"
            }
          />
        )}
        {!hideNavAndFooter && !telegramPage && <NavigationBar />}
        <main
          className={`flex flex-col flex-grow items-center w-full ${
            !hideNavAndFooter &&
            !telegramPage &&
            " mt-[61px] sm:mt-[73px] md:mt-[69px] lg:mt-[79px]"
          }`}
        >
          <Outlet />
        </main>
      </div>

      {!hideNavAndFooter && !hideFooter && !telegramPage && <Footer />}
      {token && !showSearchDarwer && !hideBottomNav && !telegramPage && (
        <BottomNav />
      )}
      {telegramListPage && !showSearchDarwer && <TelegramBottomNav />}
      {telegramListPage && !showSearchDarwer && <FloatingSearch />}
    </div>
  );
};

export default Rootlayout;
